import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock, Save } from "lucide-react";

export default function ChangePasswordCard() {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw.length < 6) {
      toast.error("Nuova password minima 6 caratteri");
      return;
    }
    if (newPw !== confirmPw) {
      toast.error("Le password non coincidono");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Password aggiornata");
      setOldPw("");
      setNewPw("");
      setConfirmPw("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore cambio password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="border border-[#2A2A35] p-6 mt-6">
      <div className="flex items-center gap-2 mb-4">
        <Lock className="w-4 h-4 text-[#FF3B30]" />
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0AB]">Cambio password</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <PWField label="Password attuale" value={oldPw} onChange={setOldPw} testid="cpw-old" />
        <PWField label="Nuova password" value={newPw} onChange={setNewPw} testid="cpw-new" />
        <PWField label="Ripeti nuova" value={confirmPw} onChange={setConfirmPw} testid="cpw-confirm" />
      </div>
      <button
        type="submit"
        disabled={saving || !oldPw || !newPw || !confirmPw}
        data-testid="cpw-submit"
        className="bg-[#FF3B30] text-white text-xs font-bold uppercase tracking-widest px-4 py-2 hover:bg-[#e02e24] transition-all flex items-center gap-2 disabled:opacity-40"
      >
        <Save className="w-3 h-3" /> {saving ? "Salvo..." : "Aggiorna password"}
      </button>
    </form>
  );
}

function PWField({ label, value, onChange, testid }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#A0A0AB] mb-2">{label}</div>
      <input
        type="password"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="w-full bg-[#141419] border border-[#2A2A35] px-3 py-2 focus:border-[#FF3B30] focus:outline-none text-sm"
      />
    </div>
  );
}
